module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hNMYa"))).then(() => parcelRequire('ljYL6'));